import { AnimatePresence ,motion} from 'framer-motion';
export default function Error({errorMsg}) {
    return (
        <AnimatePresence>
            <motion.div
                className="ErrorMessage"
                initial={{ opacity: 0, y: -6 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -6 }}
                transition={{ duration: 0.2 }}
            >
                {errorMsg}
            </motion.div>

        </AnimatePresence>
  )
}
